/* JUSTPRESS interface helpers for the new markup (no engine logic here). */
(function () {
  'use strict';
  // Start tab: a dot when the current set has designs (state lives in JPState)
  function markStart() {
    try {
      var tab = document.querySelector('.tabbar .tstart');
      if (!tab || !window.JPState || !window.JPState.read) return;
      var st = window.JPState.read();
      tab.classList.toggle('has', !!(st && st.items && st.items.length));
    } catch (e) {}
  }
  document.addEventListener('justpress:state-change', markStart);
  document.addEventListener('justpress:set-change', markStart);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', markStart); else markStart();

  // Masonry grids (.masw > .mas): measure the caption once and set how many rows it plus the gap take (--rm).
  // The picture rows (--ri) come from the server, so nothing moves while images load.
  function fit(grid) {
    var rows = parseFloat(getComputedStyle(grid).gridAutoRows);
    if (!rows || !isFinite(rows)) return;
    var cap = grid.querySelector('.pin:not([hidden]) .mt');
    if (!cap || !cap.offsetHeight) return;
    var gap = window.matchMedia('(min-width: 900px)').matches ? 28 : 20;
    var rm = Math.ceil((cap.offsetHeight + gap) / rows);
    if (String(rm) !== grid.style.getPropertyValue('--rm')) grid.style.setProperty('--rm', rm);
  }
  function fitAll() { [].forEach.call(document.querySelectorAll('.masw > .mas'), fit); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fitAll); else fitAll();
  window.addEventListener('resize', function () { clearTimeout(fitAll.t); fitAll.t = setTimeout(fitAll, 120); });
  document.addEventListener('justpress:search-results-rendered', fitAll);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitAll);

  // Add-to-set mode (?jp_add_to_set=1, set by the engine when a set is being filled): links from design cards and
  // series cards keep the flag, so the design page returns to the set (what the live jp-ux-130.js did).
  // Brand words the engine prints stay untranslated.
  function withFlag(href) {
    try {
      var u = new URL(href, location.origin);
      if (u.origin !== location.origin) return href;
      u.searchParams.set('jp_add_to_set', '1');
      return u.pathname + u.search + u.hash;
    } catch (e) { return href; }
  }
  function decorate() {
    [].forEach.call(document.querySelectorAll('.jp-p0-spaces,[data-jp-p0-step="cart"]'), function (n) { n.setAttribute('translate', 'no'); });
    if (new URLSearchParams(location.search).get('jp_add_to_set') !== '1') return;
    [].forEach.call(document.querySelectorAll('.pin a[href],a.scard[href],.jp-library-card__link[href]'), function (a) {
      if (!a.dataset.jpSetFlag) { a.href = withFlag(a.href); a.dataset.jpSetFlag = '1'; }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', decorate); else decorate();
  document.addEventListener('justpress:search-results-rendered', decorate);

  // Sheets and dialogs (any [aria-modal="true"] that is open, i.e. on screen and visible): Tab and Shift+Tab stay
  // inside the top one, as aria-modal promises. Each sheet keeps its own Escape, first focus and return focus;
  // native <dialog> elements trap focus themselves. Closed sheets (hidden, off screen, transparent) are skipped.
  function shown(n) {
    var r = n.getBoundingClientRect();
    if (!r.width || !r.height || r.bottom <= 0 || r.top >= innerHeight || r.right <= 0 || r.left >= innerWidth) return false;
    for (var e = n; e && e.nodeType === 1; e = e.parentElement) {
      var cs = getComputedStyle(e);
      if (cs.visibility === 'hidden' || +cs.opacity < 0.05 || e.getAttribute('aria-hidden') === 'true') return false;
    }
    return true;
  }
  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]):not([type=hidden]),select:not([disabled]),textarea:not([disabled]),summary,[tabindex]:not([tabindex="-1"])';
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab' || e.defaultPrevented) return;
    var open = [].filter.call(document.querySelectorAll('[aria-modal="true"]:not(dialog)'), function (d) { return !d.hidden && shown(d); });
    var d = open[open.length - 1];
    if (!d) return;
    var f = [].filter.call(d.querySelectorAll(FOCUSABLE), function (n) { return n.getClientRects().length && getComputedStyle(n).visibility !== 'hidden'; });
    var a = document.activeElement;
    if (!f.length) { e.preventDefault(); return; }
    if (!d.contains(a)) { e.preventDefault(); f[0].focus(); }
    else if (e.shiftKey && (a === f[0] || a === d)) { e.preventDefault(); f[f.length - 1].focus(); }
    else if (!e.shiftKey && a === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
  });
})();
